<nav class="unav">
  <a class="nav-logo" href="pc_home.html">
    <img src="assets/img/logo.png" alt="Police Officers Connect Logo">
    <div><div class="nav-brand-name">Police Officers Connect</div><div class="nav-brand-sub">UMYO Network</div></div>
  </a>
  <button class="unav-tog" id="navTog" (click)="toggleNav()"><span></span><span></span><span></span></button>
  <ul class="unav-links" id="navLinks" [class.nav-open]="isNavOpen">
    <li><a routerLink="/" >Home</a></li>
    <li><a routerLink="/about" >About</a></li>
    <li><a routerLink="/support" >Officer Support</a></li>
    <li><a routerLink="/business">For Business</a></li>
    <li><a routerLink="/services" class="active">Type Of Services</a></li>
    <li><a routerLink="/cf">Card Features</a></li>
  </ul>
  <a href="#header" class="nav-cta">Join Now</a>
</nav>

<!-- HERO -->
<div class="page-hero">
  <div class="hero-grid"></div>
  <div style="position:relative;z-index:1;width:100%;max-width:800px;margin:0 auto;">
    <span class="hero-badge">Professional Creative &amp; Digital Services</span>
    <h1 class="hero-title">Type of <em>Services</em></h1>
    <span class="gold-bar"></span>
    <p class="hero-sub">From music registration to full-service digital marketing &mdash; premium services crafted for artists, entrepreneurs, and growing businesses.</p>
  </div>
</div>

<!-- STICKY TABS -->
<div class="svc-tabs">
  <a class="svc-tab active" href="/services#song">Song Registration</a>
  <a class="svc-tab" href="/services#video">Music Video</a>
  <a class="svc-tab" href="/services#ads">Video Ads</a>
  <a class="svc-tab" href="/services#bundles">Promo Bundles</a>
  <a class="svc-tab" href="/services#creation">Video Creation</a>
  <a class="svc-tab" href="/services#seo">SEO &amp; Marketing</a>
  <a class="svc-tab" href="/services#social">Social &amp; Web</a>
  <a class="svc-tab" href="/services#leads">Lead Gen</a>
  <a class="svc-tab" href="/services#additional">Additional</a>
</div>

<div class="page-body">

<!-- 01 SONG REGISTRATION -->
<div class="sec-divider"></div>
<section class="svc-section dark" id="song">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800">
      <span class="sec-icon">🎵</span>
      <h2 class="sec-title">Song <em>Registration Services</em></h2>
      <div class="ornament">&#9670; &#9670; &#9670;</div>
      <p class="sec-sub">Get your music properly registered and ensure you&rsquo;re receiving royalties from <strong style="color:var(--gold-light);">BMI, ASCAP, The MLC, and SoundExchange.</strong></p>
      <a href="#" class="btn-outline" style="margin-top:22px;">Read More</a>
    </div>
    <div class="why-band" data-aos="fade-up" data-aos-delay="100">
      <p>If your songs aren&rsquo;t registered with the right organizations, you&rsquo;re <strong>leaving money on the table.</strong></p>
      <p>Every time your music is streamed, performed, or broadcasted, you&rsquo;re owed royalties.</p>
      <p>These services ensure you&rsquo;re set up to <strong>collect every dollar.</strong></p>
    </div>
    <div class="tier-label" data-aos="fade-up">Choose Your Tier</div>
    <div class="row" style="max-width:760px;margin:0 auto;">
      <div class="svc-card col-lg-6" data-aos="fade-right" data-aos-delay="0"><div class="card-title">Tier 1</div><div class="card-price">$350</div><ul class="card-list"><li>11 &ndash; 50 Songs</li><li>PRO registration (BMI or ASCAP)</li><li>MLC &amp; SoundExchange registration</li><li>Metadata verification</li><li>Final registration report</li></ul></div>
      <div class="svc-card col-lg-6" data-aos="fade-left" data-aos-delay="100"><div class="card-title">Tier 2</div><div class="card-price">$600</div><ul class="card-list"><li>51 &ndash; 300 Songs</li><li>PRO registration (BMI or ASCAP)</li><li>MLC &amp; SoundExchange registration</li><li>Metadata verification</li><li>Final registration report</li></ul></div>
    </div>
    <div class="payment-box" data-aos="fade-up" data-aos-delay="150">
      <div class="payment-title">Payment Methods</div>
      <p>Cash App: <strong>$Zaecepe</strong> &nbsp;|&nbsp; Zelle: <strong>zae@zaecepe.com</strong></p>
      <p style="font-size:14px;margin-top:8px;font-style:italic;color:var(--text-muted);">Include: &ldquo;Song Registration &ndash; Tier 1&rdquo; or &ldquo;Tier 2&rdquo; in payment note</p>
    </div>
  </div>
</section>

<!-- 02 MUSIC VIDEO -->
<div class="sec-divider"></div>
<section class="svc-section brown" id="video">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800">
      <span class="sec-icon">🎥</span>
      <h2 class="sec-title">Music Video Shoot <em>&amp; Editing</em></h2>
      <div class="ornament">&#9670; &#9670; &#9670;</div>
      <p class="sec-sub">Bring your vision to life with high-quality visuals tailored for your brand and budget.</p>
      <a href="#" class="btn-outline" style="margin-top:22px;">Read More</a>
    </div>
    <div class="why-band" data-aos="fade-up" data-aos-delay="100">
      <p>A professional music video isn&rsquo;t just content &mdash; it&rsquo;s your <strong>visual identity, a marketing tool, and a first impression.</strong></p>
      <p>The right video helps you stand out, connect with fans, and elevate your artistry.</p>
    </div>
    <div class="tier-label" data-aos="fade-up">Choose Your Package</div>
    <div class="row">
      <div class="svc-card col-lg-4" data-aos="fade-up" data-aos-delay="0"><div class="card-title">Basic</div><div class="card-price">$350</div><ul class="card-list"><li>1-hour shoot</li><li>1 location</li><li>1080p edited</li><li>1 revision</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="fade-up" data-aos-delay="100"><div class="card-title">Standard</div><div class="card-price">$400</div><ul class="card-list"><li>2&ndash;3 hour shoot</li><li>Up to 2 locations</li><li>Color correction</li><li>2 revisions</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="fade-up" data-aos-delay="200"><div class="card-title">Premium</div><div class="card-price">$600</div><ul class="card-list"><li>Half-day shoot</li><li>Up to 3 locations</li><li>Direction &amp; creative support</li><li>Color grading</li></ul></div>
    </div>
    <div class="addon-block" data-aos="fade-up" data-aos-delay="150">
      <div class="addon-title">Add-Ons</div>
      <ul class="addon-list"><li>4K Output &mdash; +$100</li><li>Extra Shooting Hour &mdash; +$75/hour</li><li>Extra Revisions &mdash; +$30 each</li><li>Rush Delivery (48 hrs) &mdash; +$100</li></ul>
    </div>
    <div class="payment-box" data-aos="fade-up" data-aos-delay="200">
      <div class="payment-title">Payment</div>
      <p>Cash App: <strong>$Zaecepe</strong> &nbsp;|&nbsp; Zelle: <strong>zae@zaecepe.com</strong></p>
      <p style="font-size:14px;margin-top:8px;font-style:italic;color:var(--text-muted);">Include: &ldquo;Music Video &ndash; [Package Name]&rdquo;</p>
    </div>
  </div>
</section>

<!-- 03 VIDEO ADS -->
<div class="sec-divider"></div>
<section class="svc-section dark" id="ads">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800">
      <span class="sec-icon">📢</span>
      <h2 class="sec-title">Video Ads <em>&amp; Promo Services</em></h2>
      <div class="ornament">&#9670; &#9670; &#9670;</div>
      <p class="sec-sub"><strong style="color:var(--gold-light);">Capture attention. Drive results. Grow your brand.</strong> From whiteboard animations to live video and 3D characters.</p>
    </div>
    <div class="perfect-wrap" data-aos="fade-up" data-aos-delay="80">
      <div class="perfect-title">Perfect For</div>
      <div class="perfect-tags"><span class="ptag">Small Businesses</span><span class="ptag">Entrepreneurs</span><span class="ptag">Product Launches</span><span class="ptag">Local Events</span><span class="ptag">Social Media Campaigns</span><span class="ptag">YouTube / Facebook / Instagram Ads</span></div>
    </div>
    <div class="why-band" data-aos="fade-up" data-aos-delay="100">
      <p>In today&rsquo;s world, video is the most powerful marketing tool available.</p>
      <p>Engaging video ads <strong>increase conversions, boost brand awareness,</strong> and connect with your target audience instantly.</p>
    </div>
    <div class="tier-label" data-aos="fade-up">Choose Your Package</div>
    <div style="max-width:720px;margin:0 auto;display:flex;flex-direction:column;gap:2px;">
      <div class="svc-card" data-aos="fade-up" data-aos-delay="0"><div class="card-title">Basic</div><div class="card-price">$250</div><ul class="card-list"><li>30&ndash;60 second whiteboard or 2D explainer</li><li>Script assistance</li><li>Royalty-free background music</li><li>720p video, 1 revision</li></ul></div>
      <div class="svc-card" data-aos="fade-up" data-aos-delay="80"><div class="card-title">Standard</div><div class="card-price">$400</div><ul class="card-list"><li>60&ndash;90 second animated or live footage promo</li><li>Script writing included</li><li>Voiceover (1 language/accent)</li><li>Logo animation, color grading, 1080p, 2 revisions</li></ul></div>
      <div class="svc-card" data-aos="fade-up" data-aos-delay="160"><div class="card-title">Premium</div><div class="card-price">$650</div><ul class="card-list"><li>Up to 2-minute custom video (2D/3D, whiteboard or hybrid)</li><li>Full scriptwriting and creative direction</li><li>Voiceover with SFX, stock footage &amp; animation</li><li>3 revisions + social media format</li></ul></div>
    </div>
    <div class="addon-block" data-aos="fade-up" data-aos-delay="150">
      <div class="addon-title">Add-Ons</div>
      <ul class="addon-list"><li>4K Output &mdash; +$100</li><li>Extra Revision &mdash; +$30 each</li><li>Rush Delivery (72 hrs) &mdash; +$125</li><li>Custom 3D Character/Scene &mdash; +$150</li><li>Multi-format Delivery &mdash; +$50</li></ul>
    </div>
  </div>
</section>

<!-- 04 PROMO BUNDLES -->
<div class="sec-divider"></div>
<section class="svc-section brown" id="bundles">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800"><span class="sec-icon">📈</span><h2 class="sec-title">Full-Service Business <em>Promo Bundles</em></h2><div class="ornament">&#9670; &#9670; &#9670;</div></div>
    <div class="row">
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Starter Growth Pack</div><div class="card-price">$850</div><ul class="card-list"><li>1 Standard Promo Video (60&ndash;90 sec)</li><li>SEO Optimization for 3 pages</li><li>Social Media Setup + 2 Branded Templates</li><li>Business Contact List (200 leads)</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="100"><div class="card-title">Digital Business Builder</div><div class="card-price">$1,500</div><ul class="card-list"><li>1 Premium Promo Video</li><li>Basic Website (up to 5 pages)</li><li>Web Hosting (1st Year Free)</li><li>Email/Video Blast to 1,000 Contacts</li><li>Social Media Management (30 days, 3 platforms)</li><li>Direct Mail Postcard Design</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="200"><div class="card-title">Ultimate Growth Machine</div><div class="card-price">$2,800</div><ul class="card-list"><li>2 Custom Promo Videos</li><li>App UI Mockup + Landing Page</li><li>Lead Gen Contact List (1,000 leads)</li><li>Direct Mail Postcard Campaign</li><li>2 Months Social Media Management</li><li>Monthly Email Marketing Setup</li></ul></div>
    </div>
    <div class="payment-box" data-aos="fade-up" data-aos-delay="200">
      <div class="payment-title">Payment Methods</div>
      <p>Cash App: <strong>$Zaecepe</strong> &nbsp;|&nbsp; Zelle: <strong>zae@zaecepe.com</strong></p>
      <p style="font-size:14px;margin-top:8px;font-style:italic;color:var(--text-muted);">Include: &ldquo;Promo Video &ndash; [Package Name]&rdquo;</p>
    </div>
  </div>
</section>

<!-- 05 VIDEO CREATION -->
<div class="sec-divider"></div>
<section class="svc-section dark" id="creation">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800"><span class="sec-icon">🎞</span><h2 class="sec-title">Video <em>Creation Services</em></h2><div class="ornament">&#9670; &#9670; &#9670;</div></div>
    <div class="row">
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Whiteboard Animation</div><ul class="card-list"><li>Up to 60 sec &mdash; $150</li><li>60&ndash;90 sec &mdash; $200</li><li>90&ndash;120 sec &mdash; $250</li></ul><div class="card-note">Add-ons: Voiceover +$50, Scriptwriting +$40</div></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="60"><div class="card-title">2D Character Animation</div><ul class="card-list"><li>Up to 60 sec &mdash; $200</li><li>60&ndash;90 sec &mdash; $275</li><li>90&ndash;120 sec &mdash; $325</li></ul><div class="card-note">Add-ons: Custom character +$50 each</div></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="120"><div class="card-title">3D Character / Scene Animation</div><ul class="card-list"><li>30&ndash;60 sec &mdash; $300</li><li>60&ndash;90 sec &mdash; $400</li><li>Custom Full Scene &mdash; From $600+</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Live-Action Video Editing</div><ul class="card-list"><li>Basic Cut + Music &mdash; $125</li><li>Motion Graphics &amp; Transitions &mdash; $200</li><li>Full Branding (Logo, Lower Thirds, CTA) &mdash; $250+</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="80"><div class="card-title">Promo Video Production</div><ul class="card-list"><li>Local Shoot (1-hour, 1 location) &mdash; $300</li><li>Half-day Shoot (3 locations) &mdash; $500</li><li>Full-day Custom Production &mdash; $800+</li></ul></div>
    </div>
  </div>
</section>

<!-- 06 SEO -->
<div class="sec-divider"></div>
<section class="svc-section brown" id="seo">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800"><span class="sec-icon">🌐</span><h2 class="sec-title">Digital Marketing <em>&amp; SEO</em></h2><div class="ornament">&#9670; &#9670; &#9670;</div></div>
    <div class="tier-label" data-aos="fade-up">SEO Services</div>
    <div class="row">
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Basic SEO Setup</div><div class="card-price">$200</div><ul class="card-list"><li>3 Pages Optimized</li><li>Keyword integration</li><li>Title / meta setup</li><li>Image alt tags</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="80"><div class="card-title">Full Website SEO</div><div class="card-price">$450</div><ul class="card-list"><li>Up to 10 Pages</li><li>Keyword Research &amp; Metadata</li><li>Image Optimization</li><li>URL Structure &amp; Internal Linking</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="160"><div class="card-title">Ongoing SEO Management</div><div class="card-price">$270<span>/mo</span></div><ul class="card-list"><li>Keyword tracking</li><li>Rank monitoring</li><li>Content optimization</li></ul></div>
    </div>
    <div class="tier-label" data-aos="fade-up" style="margin-top:40px;">Backlink Building</div>
    <div class="row">
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Starter Backlink Pack</div><div class="card-price">$175</div><ul class="card-list"><li>10 High-DA Backlinks</li><li>Contextual, directory, blog comments</li><li>White-hat only</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="80"><div class="card-title">Growth Backlink Pack</div><div class="card-price">$295</div><ul class="card-list"><li>25 High-DA Backlinks</li><li>Guest posts &amp; citations</li><li>Article submissions</li></ul></div>
      <div class="svc-card col-lg-4" data-aos="flip-left" data-aos-delay="160"><div class="card-title">Premium Authority Pack</div><div class="card-price">$550</div><ul class="card-list"><li>50+ High-Quality Backlinks</li><li>Custom strategy</li><li>Outreach-based links, DA 50+</li></ul></div>
    </div>
  </div>
</section>

<!-- 07 SOCIAL & WEB -->
<div class="sec-divider"></div>
<section class="svc-section dark" id="social">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800"><span class="sec-icon">📱</span><h2 class="sec-title">Social Media <em>&amp; Web</em></h2><div class="ornament">&#9670; &#9670; &#9670;</div></div>
    <div class="row" style="margin-bottom:2px;">
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Social Media Management</div><ul class="card-list"><li>1 Platform (3 posts/week) &mdash; $150/month</li><li>3 Platforms (3&ndash;4 posts/week each) &mdash; $350/month</li></ul><div class="card-note">Add-on: Monthly Strategy Report &mdash; +$50</div></div>
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="80"><div class="card-title">Email Marketing / Video Blast</div><ul class="card-list"><li>Design + Send to 1,000 contacts &mdash; $125</li><li>Video Email Setup &mdash; $150</li><li>Monthly Campaign (3 sends) &mdash; $250</li></ul></div>
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Web Development</div><ul class="card-list"><li>One-page Landing Site &mdash; $200</li><li>3&ndash;5 Page Business Site &mdash; $400</li><li>Full Custom Website (10 pages) &mdash; From $600</li></ul><div class="card-note">Add-on: eCommerce Setup &mdash; +$150</div></div>
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="80"><div class="card-title">Web Hosting</div><ul class="card-list"><li>Basic Hosting Plan &mdash; $75+/year</li><li>With Security &amp; Backup &mdash; $100+/year</li></ul></div>
    </div>
    <div class="tier-label" data-aos="fade-up" style="margin-top:40px;">App &amp; UI/UX Design</div>
    <div class="row" style="max-width:760px;margin:0 auto;">
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Mobile App UI Mockup</div><ul class="card-list"><li>3&ndash;5 Screens &mdash; $150</li><li>6&ndash;10 Screens &mdash; $250</li></ul><div class="card-note">Add-on: Interactive Prototype &mdash; +$75</div></div>
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="80"><div class="card-title">App Development (Basic MVP)</div><ul class="card-list"><li>Pricing starts at $800+ (quote-based)</li></ul></div>
    </div>
  </div>
</section>

<!-- 08 LEAD GEN -->
<div class="sec-divider"></div>
<section class="svc-section brown" id="leads">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800"><span class="sec-icon">📤</span><h2 class="sec-title">Lead Generation <em>&amp; Print Marketing</em></h2><div class="ornament">&#9670; &#9670; &#9670;</div></div>
    <div class="row" style="max-width:860px;margin:0 auto;">
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="0"><div class="card-title">Business Contact List</div><ul class="card-list"><li>200 Leads &mdash; $115</li><li>500 Leads &mdash; $210</li><li>1,000 Leads &mdash; $350</li></ul><div class="card-note">Custom targeting: industry, location, role</div></div>
      <div class="svc-card col-md-6" data-aos="flip-left" data-aos-delay="100"><div class="card-title">Direct Mail Postcards</div><ul class="card-list"><li>Design Only &mdash; $120</li><li>Design + List Targeting &mdash; $215+</li><li>Print &amp; Mail Coordination &mdash; From $250 (500 pcs)</li></ul></div>
    </div>
  </div>
</section>

<!-- 09 ADDITIONAL PLATFORMS -->
<div class="sec-divider"></div>
<section class="svc-section dark" id="additional">
  <div class="container">
    <div class="sec-head" data-aos="fade-up" data-aos-duration="800">
      <span class="sec-icon">🌐</span>
      <h2 class="sec-title">Additional <em>Platforms</em></h2>
      <div class="ornament">&#9670; &#9670; &#9670;</div>
      <p class="sec-sub">Explore our growing network of digital platforms built for community, connection, and creativity.</p>
    </div>
    <div class="platform-grid">

      <div class="platform-card" data-aos="flip-left" data-aos-delay="0">
        <div class="platform-name">🚔 Officer Marketplace</div>
        <p class="platform-desc">Connect police officers, departments, and verified service providers in one secure professional network.</p>
        <a href="https://pdtalks.site/welcome" target="_blank" class="platform-btn">Visit Network &#8599;</a>
      </div>

      <div class="platform-card" data-aos="flip-left" data-aos-delay="60">
        <div class="platform-name">📅 Duty & Appointment Booking</div>
        <p class="platform-desc">Schedule meetings, duty assignments, consultations, and official appointments efficiently.</p>
        <a href="https://umyoappt.site" target="_blank" class="platform-btn">Visit Scheduler &#8599;</a>
      </div>

      <div class="platform-card" data-aos="flip-left" data-aos-delay="120">
        <div class="platform-name">📡 Live Communication</div>
        <p class="platform-desc">Secure live streaming and communication for briefings, updates, and internal coordination.</p>
        <a href="https://vibetalktv.com" target="_blank" class="platform-btn">Visit Live Platform &#8599;</a>
      </div>

      <div class="platform-card" data-aos="flip-left" data-aos-delay="0">
        <div class="platform-name">📝 Officer Updates</div>
        <p class="platform-desc">Share updates, announcements, and important field information within the officer network.</p>
        <a href="https://pdtweets.site/guest" target="_blank" class="platform-btn">Visit Updates &#8599;</a>
      </div>

      <div class="platform-card" data-aos="flip-left" data-aos-delay="60">
        <div class="platform-name">🎥 Virtual Briefings</div>
        <p class="platform-desc">Host and join secure virtual meetings, training sessions, and departmental briefings.</p>
        <a href="https://umyoconvo.site" target="_blank" class="platform-btn">Visit Conference &#8599;</a>
      </div>

      <div class="platform-card" data-aos="flip-left" data-aos-delay="120">
        <div class="platform-name">🎧 Audio Broadcast System</div>
        <p class="platform-desc">Stream official audio broadcasts, alerts, and internal communication channels.</p>
        <a href="https://umyomusic.com" target="_blank" class="platform-btn">Visit Audio System &#8599;</a>
      </div>

    </div>
    <div class="payment-box" style="margin-top:60px;" data-aos="fade-up" data-aos-delay="150">
      <div class="payment-title">Payment Options</div>
      <p>Cash App: <strong>$Zaecepe</strong> &nbsp;|&nbsp; Zelle: <strong>zae@zaecepe.com</strong></p>
      <p style="font-size:14px;margin-top:8px;font-style:italic;color:var(--text-muted);">Include service name in payment note &mdash; e.g., &ldquo;Whiteboard &ndash; 60 sec&rdquo;</p>
    </div>
  </div>
</section>

</div>

<!-- FOOTER -->
<footer class="site-footer">
  <div class="footer-inner">
    <div>
      <div class="footer-logo">
        <img src="assets/img/logo.png" alt="Police Officers Connect">
      </div>
      <div class="footer-brand">Police Officers Connect</div>
      <div class="footer-sub-txt">UMYO Network</div>
      <a class="footer-url" rputerLink="/">🌐 www.umyopd.site</a>
    </div>
    <div>
      <div class="footer-col-title">Navigation</div>
      <ul class="footer-links ps-0">
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/about">About the Platform</a></li>
        <li><a routerLink="/support">Officer &amp; Family Support</a></li>
        <li><a routerLink="/business">For Businesses</a></li>
        <li><a routerLink="/services">Servcies</a></li>
        <li><a routerLink="/cf">Card Features</a></li>
        <li><a routerLink="/terms">Terms & Condition</a></li>
      </ul>
    </div>
    <div>
      <div class="footer-col-title">Contact</div>
      <div class="footer-contact">
        <div><strong style="color:var(--white);">UMYO Police Connect</strong></div>
        <div>UMYO Network</div>
        <div>3225 Martin Luther King Blvd</div>
        <div>Dallas, Texas 75210</div>
        <div><a routerLink="/">www.umyopd.site</a></div>
      </div>
    </div>
  </div>
</footer>
<div class="footer-bottom">&#169; 2025 UMYO Police Connect &middot; Built for Officers &middot; Powered by Community &middot; Network. Support. Grow. Recognize.</div>